<div class="left-sidebar">
  <mat-nav-list class="menu-list">
    <ng-container *ngTemplateOutlet="menuTemplate; context: { $implicit: menus }">

    </ng-container>
  </mat-nav-list>

</div>

<ng-template
  #menuTemplate
  let-items>
  <div
    class="menu-items-container"
    *ngFor="let i of items">
    <h3
      class="menu-group-name"
      mat-subheader
      *ngIf="i?.items?.length > 0 && i.available && i.available()">
      {{ i.label }}
    </h3>
    <mat-list-item
      *ngIf="(!i?.items || i?.items?.length === 0) && i.available && i.available()"
      class="menu-list-item"
      [class.disabled]="i.disable && i.disable()">
      <a
        matLine
        (click)="clickMenuItemHandler(i)">
        {{ i.label }}
      </a>
      <ng-container *ngIf="i?.items?.length > 0 && i.available && i.available()">
        <ng-container *ngTemplateOutlet="menuTemplate; context: { $implicit: i?.items }"></ng-container>
      </ng-container>
    </mat-list-item>

    <ng-container *ngIf="i?.items?.length > 0 && i.available && i.available()">
      <ng-container *ngTemplateOutlet="menuTemplate; context: { $implicit: i?.items }"></ng-container>
    </ng-container>
    <mat-divider *ngIf="i.available && i.available()"></mat-divider>
  </div>
</ng-template>
